export const houseNumberPattern = {
  value: /^[1-9]\d{0,9}$/i,
  message: 'Vul een geldig huisnummer in.',
};
